import type { ConnectedUser, Settings, User } from '@graphit/types'
import axios from 'axios'

import env from '../environments'

export async function getMe() {
	const response = await axios.get(env.apiUrl + '/users/me')

	return response.data as ConnectedUser
}

export async function updateUser(user: Partial<User>) {
	await axios.put(env.apiUrl + '/users', user)
}

export async function updateSettings(settings: Settings) {
	await axios.put(env.apiUrl + '/users/settings', settings)
}

export async function setLastViewedCartography(cartographyId: string) {
	await axios.put(env.apiUrl + `/users/me/last-viewed-cartography/${cartographyId}`)
}

export async function setLastViewedWorkspace(workspaceId: string) {
	await axios.put(env.apiUrl + `/users/me/last-viewed-workspace/${workspaceId}`)
}
